import React from "react";

function EnqueryData() {
    // Sample lead data (replace with API later)
    const enquiryList = [
        {
            id: 1,
            promisedLeads: 100,
            consumedLeads: 80,
            balancedLeads: 20,
            startDate: "2025-09-01",
            endDate: "2025-09-30",
            status: "Active",
        },
        {
            id: 2,
            promisedLeads: 50,
            consumedLeads: 50,
            balancedLeads: 0,
            startDate: "2025-08-01",
            endDate: "2025-08-31",
            status: "Completed",
        },
        {
            id: 3,
            promisedLeads: 75,
            consumedLeads: 30,
            balancedLeads: 45,
            startDate: "2025-09-10",
            endDate: "2025-09-25",
            status: "In Progress",
        },
    ];

    return (
        <div>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "15px",
                    fontSize: "16px",
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "rgb(177 93 198)", color: "white" }}>
                        <th style={thStyle}>ID</th>
                        <th style={thStyle}>Promised Leads</th>
                        <th style={thStyle}>Consumed Leads</th>
                        <th style={thStyle}>Balanced Leads</th>
                        <th style={thStyle}>Start Date</th>
                        <th style={thStyle}>End Date</th>
                        <th style={thStyle}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {enquiryList.map((item) => (
                        <tr key={item.id}>
                            <td style={tdStyle}>{item.id}</td>
                            <td style={tdStyle}>{item.promisedLeads}</td>
                            <td style={tdStyle}>{item.consumedLeads}</td>
                            <td style={tdStyle}>{item.balancedLeads}</td>
                            <td style={tdStyle}>{item.startDate}</td>
                            <td style={tdStyle}>{item.endDate}</td>
                            <td style={tdStyle}>{item.status}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

// Inline styles
const thStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
    fontWeight: "bold",
};

const tdStyle = {
    border: "1px solid #ccc",
    padding: "10px",
};

export default EnqueryData;
